import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

import { DownArrow } from '../DownArrow';

const Wrapper = styled.div`
  min-height: calc(100vh - ${props => props.includeBanner ? 80 : 50}px);
  height: auto;
  width: 100vw;
  display: flex;
  flex-direction: row;
  padding-top: ${props => props.includeBanner ? 80 : 50}px;

  @media only screen and (min-width: 769px) {
    min-height: calc(100vh - ${props => props.includeBanner ? 130 : 80}px);
    padding-top: ${props => props.includeBanner ? 130 : 80}px;
  }
`;


const InnerWrapper = styled.div`
  padding: 0 40px;
  margin: auto;
  text-align: center;

  @media only screen and (min-width: 769px) {
    width: ${props => props.width}px;
  }
`;


const DownArrowContainer = styled.div`
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-items: center;
`

export const OpeningPanelCenter = ({children, width=600, showDownArrow=false, }) => {

  return (
    <Wrapper style={isMobile ? {flexDirection: 'column'} : {}}>
      <InnerWrapper width={width}>
        {children}
      </InnerWrapper>
      {showDownArrow &&
        <DownArrowContainer>
          <DownArrow color={"var(--black)"}/>
        </DownArrowContainer>
      }
    </Wrapper>
  );
};
